<template>
  <grid-container class="sjt-container">
    <p>Acest instrument de evaluare online este o oportunitate pentru tine de a-ți demonstra abilitățile și cunoștințele pentru această poziție.</p>

    <p>Ca parte a procesului, ți-se va cere să participi la două teste de evaluare.</p>

    <br>

    <h5><u>Te rugăm să urmezi instrucțiunile de mai jos înainte de a continua:</u></h5>

    <ul>
      <li>Aveți <b>1 oră și 30 de minute</b> pentru a finaliza ambele evaluări.</li>
      <li>Puteți vedea o numărătoare inversă a timpului disponibil în partea de sus a ecranului.</li>
      <li>Odată ce începeți evaluarea, <b>nu o puteți opri sau întrerupe</b> - așa că vă rugăm să vă asigurați că ați alocat suficient timp pentru a finaliza cu succes evaluările.</li>
      <li>După ce terminați prima evaluare, cronometrul va continua să ruleze, așa că vă rugăm să vă asigurați că începeți a doua evaluare cât mai curând posibil.</li>
      <li>Încercați să mențineți distracția la minimum în timpul evaluării; cum ar fi închiderea tuturor programelor, inclusiv a e-mailului.</li>
      <li>Odată ce ați furnizat răspunsul, nu vi se va permite să vă întoarceți și să vă schimbați răspunsul - așa că vă rugăm să vă asigurați că aveți încredere în răspunsul dvs. înainte de a continua cu următoarea întrebare.</li>
      <li>Veți avea nevoie de o conexiune stabilă la internet pentru a participa la evaluare.</li>
      <li><b>Calculatoarele sau telefoanele mobile nu sunt permise.</b></li>
    </ul>

    <br>

    <h5><u>În timpul evaluării:</u></h5>

    <p>Ca parte a procesului de evaluare, vi se vor afișa diverse întrebări și probleme la care trebuie să răspundeți.</p>

    <p>Pentru a oferi răspunsul dumneavoastră și a trece la următoarea întrebare; vi se va cere să bifați varianta/variantele pe care le considerați corecte.</p>

    <p>Odată ce ați trimis răspunsul, puteți trece la următoarea întrebare</p>

    <br>

    <h5><u>Support</u></h5>
    <p>Dacă aveți întrebări, vă rugăm să ne contactați la <a class="link" href="mailto:info@owiwi.co.uk">info@owiwi.co.uk</a> și vom fi bucuroși să vă ajutăm!</p>

    <p><b>Pentru a începe evaluarea, faceți clic pe “{{ $t('TakeTheTest') }}” de mai jos.</b></p>

    <br>

    <p><b>Mult noroc!</b></p>

    <br>

    <el-button @click="openDialog" type="primary">
      {{ $t('TakeTheTest') }}
    </el-button>

    <ElDialog
      append-to-body
      title="Esti sigur?"
      custom-class="dialog-size-550"
      :visible.sync="confirmDialog"
    >

      <div class="text-center">
        <p>TAceasta este o evaluare cronometrată cu o oră și jumătate disponibilă. Odată ce începeți, nu veți putea întrerupe sau opri procesul. Ești sigur că ești gata să începi?</p>
      </div>

      <span
        slot="footer"
        class="dialog-footer"
      >
      <ElButton
          type="secondary"
          @click="confirmDialog = false"
        >
          NU
        </ElButton>
        <ElButton
          type="primary"
          @click="startTest()"
        >
          DA
        </ElButton>
      </span>
    </ElDialog>

    <ElDialog
      append-to-body
      title="Select Language"
      custom-class="dialog-size-550"
      :visible.sync="selectLang"
    >

      <div class="text-center">
        <el-radio-group v-model="language">
          <el-radio-button label="en">English</el-radio-button>
          <el-radio-button label="el">Ελληνικά - Greek</el-radio-button>
        </el-radio-group>
      </div>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <ElButton
          type="primary"
          :disabled="!language"
          @click="selectLanguage()"
        >
          {{ $t('TakeTheTest') }}
        </ElButton>
      </span>
    </ElDialog>
  </grid-container>
</template>

<script>
import axios from '@/axios/axios'

export default {
  name: 'Start',
  computed: {
    langKey() {
      return this.$store.getters.langKey
    },

    timeUp() {
      return this.$store.getters.timeUp
    }
  },
  data() {
    return {
      confirmDialog: false,
      selectLang: false,
      language: null
    }
  },
  created() {
    if (this.timeUp) {
      this.$router.replace('/sjt/timeup')
    }
    if (!this.langKey) {
      this.$store.commit('langKey', 'en')
    }
  },
  methods: {
    openDialog() {
      this.confirmDialog = true
    },
    startTest() {
      if (this.langKey) {
        this.confirmDialog = false
        this.selectLang = false
        this.$store.commit('startGame')
        this.$router.replace('/sjt')
      }
      else {
        this.selectLang = true
      }
    },

    selectLanguage() {
      axios.post('game/language', {
        playerResultId: this.$store.getters.playerResultId,
        langKey: this.language
      })
        .then(res => {
          this.$store.commit('langKey', this.language)
          this.$i18n.locale = this.language
          this.startTest()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .link {
    font-weight: 600;
    text-decoration: underline;
  }
</style>
